import { render } from "./InlineMessage.vue?vue&type=template&id=7156f424"
import script from "./InlineMessage.vue?vue&type=script&lang=js"
export * from "./InlineMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__